const DIET_DAY_BAG_STATUS = {
  DISABLED: 'DISABLED',
  DISABLED_WITH_BAG: 'DISABLED_WITH_BAG',
  DELIVERED_NOT_RATED_BLOCKED: 'DELIVERED_NOT_RATED_BLOCKED',
  DELIVERED_RATED_BLOCKED: 'DELIVERED_RATED_BLOCKED',
  DELIVERED_RATED_PARTIALLY_BLOCKED: 'DELIVERED_RATED_PARTIALLY_BLOCKED',
  DELIVERED_NOT_RATED_CAN_RATE: 'DELIVERED_NOT_RATED_CAN_RATE',
  DELIVERED_RATED_CAN_RATE: 'DELIVERED_RATED_CAN_RATE',
  DELIVERED_RATED_PARTIALLY_CAN_RATE: 'DELIVERED_RATED_PARTIALLY_CAN_RATE',
  NOT_DELIVERED_BLOCKED: 'NOT_DELIVERED_BLOCKED',
  NOT_DELIVERED_WITH_CONFIGURABLE_ALL: 'NOT_DELIVERED_WITH_CONFIGURABLE_ALL',
  NOT_DELIVERED_CAN_SELECT_MENU: 'NOT_DELIVERED_CAN_SELECT_MENU',
  NOT_DELIVERED_HAS_SELECTED_MENU: 'NOT_DELIVERED_HAS_SELECTED_MENU',
  NOT_DIET_CAN_PLACE_ORDER: 'NOT_DIET_CAN_PLACE_ORDER',
  NOT_DIET_CANT_PLACE_ORDER: 'NOT_DIET_CANT_PLACE_ORDER',
  NOT_DELIVERED_WITH_CONFIGURABLE_WITHOUT_MENU:
    'NOT_DELIVERED_WITH_CONFIGURABLE_WITHOUT_MENU',
  SUBSCRIPTION_SUSPENDED: 'SUBSCRIPTION_SUSPENDED',
  ERROR_ON_RENEW: 'ERROR_ON_RENEW',
};

export default DIET_DAY_BAG_STATUS;
